export const GET_FILTERS_DATA = "GET_FILTERS_DATA";
export const GET_FILTERS_DATA_SUCCESS = "GET_FILTERS_DATA_SUCCESS";
export const GET_FILTERS_DATA_FAIL= "GET_FILTERS_DATA_FAIL";

// set filters data to state
export const SET_FILTERS_DATA = "SET_FILTERS_DATA";
export const SET_FILTERS_DATA_SUCCESS = "SET_FILTERS_DATA_SUCCESS";
export const SET_FILTERS_DATA_FAIL= "SET_FILTERS_DATA_FAIL";